import React, { useMemo } from 'react';
import './ParallaxStars.css';

// A single layer of stars that scrolls horizontally and loops seamlessly.
// `speed` controls how fast the layer moves (higher = faster).
// `count` is the number of stars rendered in one screen width.
const StarLayer = ({ speed, count, size = 2, opacity = 1 }) => {
  // Generate random star positions for one screen width, then duplicate the
  // set shifted by one screen so the layer (which is 200% wide) tiles seamlessly.
  const stars = useMemo(() => {
    const base = Array.from({ length: count }).map(() => ({
      top: Math.random() * 100,        // percent of screen height
      left: Math.random() * 50,        // percent of the 200%-wide layer (= one screen)
    }));

    return [
      ...base,
      ...base.map((star) => ({ ...star, left: star.left + 50 })),
    ];
  }, [count]);

  return (
    <div
      className="star-layer"
      style={{ animationDuration: `${30 / speed}s` }}
    >
      {stars.map((star, index) => (
        <span
          key={index}
          className="star"
          style={{
            top: `${star.top}%`,
            left: `${star.left}%`,
            width: size,
            height: size,
            opacity,
          }}
        />
      ))}
    </div>
  );
};

// Three layers moving at different speeds create a parallax depth effect.
const ParallaxStars = () => {
  return (
    <div className="parallax-stars">
      {/* Lower speed => slower movement for "far" stars */}
      <StarLayer speed={0.3} count={50} size={1} opacity={0.6} />
      <StarLayer speed={0.7} count={30} size={2} opacity={0.8} />
      <StarLayer speed={1}   count={20} size={3} opacity={1} />
    </div>
  );
};

export default ParallaxStars;
